import AppRouter from "./app/router/AppRouter";

function App() {
  return (
    <AppRouter />
  );
}

export default App;
